import { _ } from "i18n";
import { Cell } from "./Cell";
import { StatusCell } from "./StatusCell";
import { ActionsCell } from "./ActionsCell";
import { Task } from "types/apiManagement/task";

interface CellProps {
    value?: string | number | null;
    row?: {
        original: Task;
    };
}

export const VideoSourceTableCell = {
    eyeballGameId: ({ value }: CellProps) => <Cell variant="data" value={value} />,
    
    videoId: ({ value }: CellProps) => <Cell variant="data" value={value} />,
    
    matchId: ({ value }: CellProps) => <Cell variant="data" value={value} />,
    
    gameDate: ({ value }: CellProps) => <Cell variant="date" value={value} />,
    
    updatedAt: ({ value }: CellProps) => <Cell variant="date" value={value} />,
    
    league: ({ value }: CellProps) => <Cell variant="data" value={value} />,
    
    leagueCountry: ({ value }: CellProps) => <Cell variant="data" value={value} />,
    
    homeTeam: ({ value }: CellProps) => <Cell variant="data" value={value} />,
    
    awayTeam: ({ value }: CellProps) => <Cell variant="data" value={value} />,
    
    videoStatus: (props: CellProps) => <StatusCell {...props} type="video" />,
    
    teamsheetStatus: (props: CellProps) => <StatusCell {...props} type="teamsheet" />,
    
    actions: ({ row }: CellProps) => (
        <ActionsCell
            actions={[
                {
                    type: 'link',
                    to: `/admin/videos/match/${row?.original.eyeballGameId}`,
                    label: "video-tasks.table.link.teamsheet",
                    isTranslationKey: true,
                    disabled: !row?.original.eyeballGameId
                }
            ]}
        />
    )
}; 